<template>
  <div class="item-list-filter-text">
    <h2 v-if="label" class="filter-label apartment-search-form__subtitle">{{ label }}</h2>
    <div class="input-wrapper">
      <input
        type="text"
        :placeholder="placeholder"
        v-model="inputValue"
        @input="handleInput"
        class="filter-input"
      />
      <button 
        v-if="inputValue" 
        @click="clearInput" 
        class="clear-btn"
        :aria-label="translate('Tyhjennä suodatin')"
      >
        &times;
      </button>
    </div>
  </div>
</template>

<script>
import utils from '../mixins/utils';

export default {
  name: "ItemListFilterText",
  mixins: [
    utils.translate
  ],
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inputValue: this.modelValue,
      debounceTimer: null
    };
  },
  watch: {
    // Keep local value in sync if parent changes it programmatically
    modelValue(newVal) {
      this.inputValue = newVal;
    }
  },
  methods: {
    handleInput() {
      // Clear existing timer
      if (this.debounceTimer) clearTimeout(this.debounceTimer);

      // Set new timer (300ms delay)
      this.debounceTimer = setTimeout(() => {
        this.$emit("update:modelValue", this.inputValue);
      }, 300);
    },
    clearInput() {
      this.inputValue = "";
      this.$emit("update:modelValue", "");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/definitions"; 

.item-list-filter-text {
  width: 100%;

  .filter-label {
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    margin-top: 0;
  }

  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .filter-input {
    width: 100%;
    // Padding calculation to match the button height (approx 44-50px total)
    padding: 0.6rem 0.75rem;
    padding-right: 2.5rem;
    border: 0.1rem solid $color-gray;
    border-radius: 0;
    font-size: 1rem;
    line-height: 1.5;

    &:focus {
      outline: 0.15rem solid $color-green-2025;
      border-color: transparent;
      outline-offset: -0.15rem;
    }
  }

  .clear-btn {
    position: absolute;
    right: 1rem;
    background: none;
    border: none;
    font-size: 1.5rem;
    color: $color-dark-gray;
    cursor: pointer;
    line-height: 1;
    padding: 0;

    &:hover {
      color: $color-black;
    }

  }
}

</style>
